import { Injector, runInInjectionContext } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CountryList, StateList } from '../../types';

/*
 * @FETCH COUNTRIES is a utility function to fetch a list of countries from the API.
 * is can be used in any component or service that requires country data.
 * it accepts parameter for page index, page size and will need an injector to run the http request.
 * Within the context of an Angular application.
 * */
export function fetchCountries(
  envUrl: string,
  pageIndex = 1,
  pageSize = 300,
  injector: Injector,
) {
  return runInInjectionContext(injector, () => {
    const _http = injector.get(HttpClient);
    const _url = `${envUrl}/country/?page=${pageIndex}&page_size=${pageSize}`;
    return _http.get<CountryList>(_url);
  });
}

export function fetchStates(
  envUrl: string,
  injector: Injector,
  countryId: string,
) {
  return runInInjectionContext(injector, () => {
    const _http = injector.get(HttpClient);
    const _url = `${envUrl}/state/?country_id=${countryId}&sort_by_order=asc&page=1&page_size=300`;
    return _http.get<StateList>(_url);
  });
}
